var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn btn-pdv-gradient-blue",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v(" "+_vm._s(_vm.getI18n('ACTION.filter'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }